<template>
  <div :id="id">
    <!-- Hidden slot, used as source of markdown content -->
    <slot v-if="false"></slot>

    <v-container fluid fill-height>
      <v-layout row wrap align-center py-9 mx-lg-12 mx-4>
        <div class="extra-text" v-html="html"></div>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import { renderSlotForLocale } from "../extra.js";

export default Vue.component("extra-page", {
  name: "extra-page",
  props: { id: String },
  data() {
    return {
      html: ""
    };
  },
  watch: {
    "$i18n.locale": function(locale) {
      this.renderContentsForLocale(locale);
    }
  },
  mounted() {
    this.renderContentsForLocale(this.$i18n.locale);
  },
  methods: {
    renderContentsForLocale(locale) {
      this.html = renderSlotForLocale(this.$slots, locale);
    }
  }
});
</script>

<style>
code[class^="language-"] {
  width: 100%;
  padding: 0.7em;
  color: inherit;
  font-family: SFMono-Regular, Monaco, Consolas, Liberation Mono, Menlo,
    monospace;
  font-weight: normal;
  box-shadow: none;
  background-color: #f0f0f0;
  margin: 1em 0;
}

code[class^="language-"]:before,
code[class^="language-"]:after {
  content: none;
}
</style>
